import BackEndConfig from "../interface/BackEndConfig";
import axios, { AxiosInstance } from 'axios';
import { DataPyaload } from "../interface/payload";


export default class VideoRecorderService{
    private endpoint:string;
    private headers:any;
    private instance!:AxiosInstance;
    constructor(config:BackEndConfig){
      this.endpoint=config.endpoint;
        this.headers=config.headers;
        this.instance =axios.create({
            baseURL: this.endpoint,
          });


      }

    public async PostVideo(payload:DataPyaload){
      this.headers["Content-Type"] = "multipart/form-data";
      this.instance.interceptors.request.use(
        (config) => {
          return {
            ...config,
            headers: this.headers,
          };
        },
        (e) => {
          console.log('error: ', e);
          return Promise.reject(e);
        }
      );
        const formdata = new FormData();
        formdata.append("File", payload.Stream, payload.FileName);
        formdata.append("FileName", payload.FileName);
        formdata.append("ContentType", payload.ContentType);
        formdata.append("ProjectName", payload.ProjectName);
        formdata.append("MaxVideoLength", payload.InterviewMaxLength);
        formdata.append("AustralianHeiOnUkServer", payload.AustralianHeiOnUkServer);
        return this.instance!.post("/SaveVideoFile",formdata);


    }
}



